//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//	import Xcity from '@/common/Xcity.vue'
	export default {
		data() {
			return {
				disabledValue: 'YYYYYYY',
				userInfo: [],
				DISTRICTS: [],
				position: 'default',
				showPositionValue: false,
				tiptxt: '',
				tipType: '',
				userTile: '',
				cityInfo: {
					province: '',
					city: '',
					area: ''
				},
				cityId: {
					provinceid: '',
					cityid: '',
					districtid: ''
				},
				region:'',
        CertState:''
			}

		},
		mounted() {
			this.config()
		},
		methods: {
			async config() {
				await this.getInf()
				/*this.getArea()*/
			},
			getInf() {
				let data = 'cmd=userinfo'
				this.$http.post('https://api.abeiyun.com/www/user.php', data).then(({
					data
				}) => {
					this.userInfo = data.msg;
          this.CertState =data.msg.cert_state == '审核成功' ? data.msg.cert_name : data.msg.cert_state
					/*if(data.msg.regionID){
						this.cityId.provinceid = Number(data.msg.regionID);
					}
					if(data.msg.provinceID){
						this.cityId.cityid = Number(data.msg.provinceID);
					}
					if(data.msg.cityID){
						this.cityId.districtid = Number(data.msg.cityID);
					}*/
          this.userTile = data.msg.cert_name || data.msg.ID_Mobile
				})
			},
			getArea() {
				let data = 'cmd=area_dic'
				this.$http.post('https://api.abeiyun.com/www/user.php', data).then(({
					data
				}) => {
					this.DISTRICTS = data;
					this.region = '';
					for(let i in this.DISTRICTS) {
						if(this.DISTRICTS[i].area_id == this.cityId.provinceid) {
							this.cityInfo.province = this.DISTRICTS[i].area_title
							this.region = this.DISTRICTS[i].area_title
							let province = this.DISTRICTS[i].province

							for(let j in province) {
								if(province[j].area_id == this.cityId.cityid) {
									this.cityInfo.city = province[j].area_title
									this.region += '  ' + province[j].area_title
									let city = province[j].city
									for(let k in city) {
										if(city[k].area_id == this.cityId.districtid) {
											this.cityInfo.area = city[k].area_title
											this.region += '  ' + city[k].area_title
											console.log(city[k].area_title)
										}
									}
								}
							}
						}
					}
				})
			},
			showPosition(position) {
				this.position = position
				this.showPositionValue = true
			},
			loginOut() {

				this.$http.get('https://api.abeiyun.com/www/login.php?cmd=logout').then(({
					data
				}) => {
					console.log(data);
					this.showPosition('middle')
					this.tiptxt = data.msg;
					if(data.response == 200) {
						this.$router.push('/home')
					} else {
						this.tipType = 'warn';
					}
				})
			}
		},
		components: {
//			Xcity
		},
	}



// WEBPACK FOOTER //
// ./src/components/user/safety.vue